import { createSlice } from "@reduxjs/toolkit";
import engState from "../../../constants/engagement/initialStates/engState";

// Create a Redux slice for the 'Engagement' portion of the state
export const engSlice = createSlice({
  name: "eng", // The name of the slice
  initialState: engState, // Initial state for Engagement
  reducers: {
    // Action to set Engagement data
    setEngData: (state, action) => {
      state.data = action.payload;
    },
    // Action to set Engagement Etc data
    setEngEtc: (state, action) => {
      state.etc = action.payload;
    },
    // Action to set Engagement step
    setEngStep: (state, action) => {
      state.etc.engStep = action.payload;
    },
    // Action to set the next Engagement step
    setNextEngStep: (state) => {
      state.etc.engStep = state.etc.engStep + 1;
    },
    // Action to set the previous Engagement step
    setPrevEngStep: (state) => {
      state.etc.engStep = state.etc.engStep - 1;
    },
    // Action to set Engagement type
    setEngType: (state, action) => {
      state.etc.engType = action.payload;
    },
    // Action to set whether Engagement is submittable
    setIsEngSubmittable: (state, action) => {
      state.etc.isEngSubmittable = action.payload;
    },
    // Action to increase Dynamic Fields
    setIncreaseEngDynamicFields: (state) => {
      state.etc.dynamicFields = state.etc.dynamicFields + 1;
    },
    // Action to decrease Dynamic Fields
    setDecreaseEngDynamicFields: (state) => {
      state.etc.dynamicFields = state.etc.dynamicFields - 1;
    },
    // Action to set Slider Poll Data
    setSliderPoll: (state, action) => {
      state.data.sliderPoll = action.payload;
    },
    // Action to set Poll Data
    setPoll: (state, action) => {
      state.data.poll = action.payload;
    },
    // Action to set Poll Data
    setQuiz: (state, action) => {
      state.data.quiz = action.payload;
    },
  },
});

// Export the action creators
export const {
  setEngData,
  setEngEtc,
  setEngStep,
  setNextEngStep,
  setPrevEngStep,
  setEngType,
  setIsEngSubmittable,
  setIncreaseEngDynamicFields,
  setDecreaseEngDynamicFields,
  setSliderPoll,
  setPoll,
  setQuiz,
} = engSlice.actions;

// Export the reducer
export default engSlice.reducer;
